import useClients from '@gr/portal/hooks/useClients';
import { IDropdownValue } from '../Dropdown';
import OldDropdown from '../OldDropdown';

interface IClientDropdownProps {
  value: IDropdownValue | (IDropdownValue | undefined)[] | undefined;
  onChange: (newValue: IDropdownValue | (IDropdownValue | undefined)[] | undefined) => void;
  onBlur?: () => void;
  allClients?: boolean;
  disabled?: boolean;
  errorMessage?: string | undefined;
  showError?: boolean;
  gridFilter?: boolean;
  multiple?: boolean;
  placeholder?: string;
  label?: string;
  gray?: boolean;
  noLabel?: boolean;
}

const ClientDropdown = ({
  value,
  onChange,
  onBlur,
  allClients = false,
  showError,
  disabled,
  errorMessage,
  gridFilter,
  multiple = false,
  placeholder,
  label,
  gray,
  noLabel,
}: IClientDropdownProps): JSX.Element => {

  const { query: clientsQuery } = useClients();
  const clients: IDropdownValue[] =
    clientsQuery.data?.records.map((client) => ({
      label: client.name ?? '',
      value: gridFilter ? client.name ?? '' : client.id ?? '',
      additionalData: {
        clickerGroup: client.defaultClickerGroupId,
        twoWayEnabled: client.twoWayEnabled,
      },
    })) ?? [];

  return !multiple ? (
    <OldDropdown
      label={noLabel ? '' : label ?? 'Client'}
      loading={clientsQuery.isPending}
      value={value as IDropdownValue}
      options={allClients ? clients : clients.filter((client) => client.value !== '11111111-1111-1111-1111-111111111111')}
      onChange={onChange}
      onBlur={onBlur}
      error={errorMessage}
      disabled={disabled}
      showError={showError}
      placeholder={placeholder}
      gray={gray}
    />
  ) : (
    <OldDropdown
      multiple
      loading={clientsQuery.isPending}
      label={noLabel ? '' : label ?? 'Client'}
      value={value as IDropdownValue[]}
      options={allClients ? clients : clients.filter((client) => client.value !== '11111111-1111-1111-1111-111111111111')}
      onChange={onChange}
      onBlur={onBlur}
      error={errorMessage}
      disabled={disabled}
      showError={showError}
      placeholder={placeholder}
      gray={gray}
    />
  );
};

export default ClientDropdown;
